import { CookieService } from '@/app_lib/CookieService';

const SIGNIN_REDIRECT_COOKIE = '__rdSI';

/**
 * Returns the post-signin redirect destination: __rdSI cookie value or '/'.
 * Use after successful password login or account creation (then clear cookie and navigate).
 */
export function getSignInRedirectDestination(): string {
  return CookieService.get(SIGNIN_REDIRECT_COOKIE) ?? '/';
}

/**
 * Clears the signin redirect cookie. Call after navigating to the redirect destination.
 */
export function clearSignInRedirectCookie(): void {
  CookieService.remove(SIGNIN_REDIRECT_COOKIE);
}

/**
 * Link to `/signin` that returns the user to the current page after login.
 * Bare `/` (no query) → `/signin` with no `signin_redirect`; otherwise adds `signin_redirect`.
 */
export const buildSignInRedirectUrl = (location: Location, format: 'absolute' | 'relative'): string => {
  const query = new URLSearchParams(location.search).toString();
  const pathAndQuery = `${location.pathname}${query ? `?${query}` : ''}`;

  const relativeHref =
    pathAndQuery === '/' ? '/signin' : `/signin?${new URLSearchParams([['signin_redirect', pathAndQuery]]).toString()}`;

  return format === 'absolute' ? `${location.origin}${relativeHref}` : relativeHref;
};
